import React, { Fragment, useContext, useRef, useState } from 'react';
import { deleteField, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase.config';

import { ThemeContext } from '../../context/ThemeContext';
import { Transition } from '@headlessui/react';

import { UserContext } from '../../context/AuthContext';

import InfoBox from '../info/InfoBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { debug } from 'console';

interface Props {
    photoURL: string;
    displayName: string;
    mssgText: string;
    uid: string;
    id: string;
    roomTitle: string;
    timeSent: string;
    currentTab: string;
}

const ChatBox = (props: Props) => {
    const styles = {
        container: ' flex flex-col min-w-0 mb-2 mr-4',
        infoBoxContainer: 'flex flex-col z-20 sm:w-[30vw] sm:h-[15vh] rounded-r-lg rounded-bl-lg shadow-md border-2 ',
        topInfoBox: 'flex flex-row justify-between bg-gradient-to-r ',
        userInfo: 'my-auto ml-2',
        infoBoxX: 'px-2 py-1 rounded-tr-lg border-2 text-white ',
        infoBoxBody: 'flex flex-row w-full h-full p-2 text-sm',
        userSide: 'w-full ',
        charaSide: 'w-full h-full flex flex-col justify-between ',
        timeWrapper: 'flex flex-col items-end mr-1',
        body: 'flex flex-row h-fit w-fit shadow-md rounded-xl ',
        leftSide: 'flex flex-col justify-between',
        imgContainer:
            'flex flex-row lg:min-w-[60px] lg:max-w-[60px] lg:min-h-[60px] lg:max-h-[60px] min-w-[45px] max-w-[45px] min-h-[45px] max-h-[45px] m-2 items-center rounded-xl overflow-hidden ',
        img: 'h-full w-full object-contain',
        mssgInfo: 'flex flex-col border-l-2 ',
        displayName: 'font-bold cursor-default hover:underline pt-1 pr-1 ',
        topOfMssg: 'flex flex-row justify-between bg-gradient-to-r pt-0 pl-1 pr-0 rounded-tr-xl ',
        chatBoxText: 'mx-2 pb-1',
        deleteButton: 'px-2 rounded-tr-lg ',
        icon: 'm-auto h-[10px] w-[10px] ',
        timeText: 'italic text-[12px] ',
    };

    const theme = useContext(ThemeContext);
    const mssgBoxRef = useRef(null);

    const currentUser = useContext(UserContext);
    const adminUidConfigVal: string = process.env.REACT_APP_ADMIN_USER as string;

    const [displayBoxVisible, setDisplayBoxVisible] = useState(false);
    const [userInfo, setUserInfo] = useState<{ chatName: string; charaName: string; dateJoinedRoom: string | Date }>({
        chatName: 'chatName',
        charaName: 'charaName',
        dateJoinedRoom: '00-00-0000',
    });

    const date = new Date(props.timeSent);

    const getDateFormat = () => {
        const year = String(date.getFullYear()).slice(-2);
        const month = String(date.getMonth() + 1);
        const day = String(date.getDate());

        const dateFormat = [month, day, year].join('-');
        return dateFormat;
    };

    const getTimeFormat = () => {
        let hours = date.getHours();
        let minutes: string | number = date.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';

        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        const strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };

    const infoBoxDisplayHandler = () => {
        setDisplayBoxVisible((prevState) => !prevState);
    };

    const getUserInfo = async (e: React.MouseEvent<HTMLElement>) => {
        const roomRef = doc(db, 'rooms', props.roomTitle);
        const roomDoc = await getDoc(roomRef);

        const chara = roomDoc.data()?.characters[props.uid];

        setUserInfo({
            chatName: props.displayName,
            charaName: chara.charaName,
            dateJoinedRoom: chara.dateJoined.toDate().toDateString(),
        });

        infoBoxDisplayHandler();
    };

    const deleteMessage = async () => {
        const roomRef = doc(db, 'rooms', props.roomTitle);

        try {
            updateDoc(roomRef, {
                [`${props.currentTab}.${props.id}`]: deleteField(),
            });

            console.log(props.id);
            console.log('Did supposed delete!');
        } catch (e) {
            console.log(e);
            console.log('Something went wrong!');
        }
    };

    const trashIcon = (
        <FontAwesomeIcon icon={solid('trash')} size="sm" className={styles.icon + `text-${theme?.themeColor}-100`} />
    );

    return (
        <Transition
            show={true}
            appear={true}
            as={Fragment}
            enter="transition duration-500"
            enterFrom="opacity-0 -translate-x-10"
            enterTo="opacity-100"
            leave="transition duration-250"
            leaveFrom="opacity-100"
            leaveTo="opacity-0 -translate-x-10"
        >
            <div className={styles.container} ref={mssgBoxRef}>
                <div className={styles.body + `shadow-${theme?.themeColor}-800/50 bg-${theme?.themeColor}-300`}>
                    <div className={styles.leftSide}>
                        <div className={styles.imgContainer + `bg-${theme?.themeColor}-300`}>
                            <img className={styles.img} src={props.photoURL} />
                        </div>
                        <div className={styles.timeWrapper}>
                            <p className={styles.timeText + `text-${theme?.themeColor}-900`}>{getTimeFormat()}</p>
                            <p className={styles.timeText}>{getDateFormat()}</p>
                        </div>
                    </div>
                    <div className={styles.mssgInfo + `border-${theme?.themeColor}-400`}>
                        <div className={styles.topOfMssg + `from-${theme?.themeColor}-400`}>
                            <div>
                                <p className={styles.displayName} onClick={(e) => getUserInfo(e)}>
                                    {props.displayName}:
                                </p>
                                <InfoBox
                                    isOpen={displayBoxVisible}
                                    userInfo={userInfo}
                                    handleClose={infoBoxDisplayHandler}
                                />
                            </div>
                            {currentUser?.uid == adminUidConfigVal ? (
                                <button
                                    className={
                                        styles.deleteButton +
                                        `bg-${theme?.themeColor}-500 hover:bg-${theme?.themeColor}-600 `
                                    }
                                    onClick={deleteMessage}
                                >
                                    {trashIcon}
                                </button>
                            ) : null}
                        </div>
                        <p className={styles.chatBoxText}>{props.mssgText}</p>
                    </div>
                </div>
            </div>
        </Transition>
    );
};

export default ChatBox;
